import { useState } from 'react';

import { useNotificationsContext } from '@/contexts/NotificationsContext/NotificationsContext';

type RequestFunction<T, U> = (params: T) => Promise<U>;

type RequestOptions = {
  notifyOnSuccess?: boolean;
};

export const useRequest = () => {
  const {
    actions: { setSnackbarNotification },
  } = useNotificationsContext();

  const [loading, setLoading] = useState(false);

  const request = async <T, U>(requestFunction: RequestFunction<T, U>, params: T, options?: RequestOptions) => {
    const fetcher = () => requestFunction(params);
    const id = requestFunction.name;
    setLoading(true);
    try {
      const result = await fetcher();
      if (options?.notifyOnSuccess !== false) {
        setSnackbarNotification({
          msg: `${id}_fulfilled`,
          level: 'success',
        });
      }
      return result;
    } catch (error) {
      setSnackbarNotification({
        msg: `${id}_rejected`,
        level: 'error',
        error,
      });
      throw error;
    } finally {
      setLoading(false);
    }
  };

  return { request, loading };
};
